import { BilletterieCustomerPaymentMode, PaymentMethodPreset } from '@cpce/database/enums';
import { z } from 'zod';
export const CUSTOMER_PAYMENT_MODE_PRESETS = {
    [BilletterieCustomerPaymentMode.carte]: PaymentMethodPreset.carteEncaissee,
    [BilletterieCustomerPaymentMode.cheque]: PaymentMethodPreset.chequeEncaisse,
    [BilletterieCustomerPaymentMode.especes]: PaymentMethodPreset.especes,
};
const CLOSED_ORDER_STATES = new Set(['cancelled', 'refunded']);
/** A deferred order the billetterie has not cancelled: the salarié owes the CSE for it. */
export const isAttachableOrder = (order) => order.isDeferredPayment &&
    !CLOSED_ORDER_STATES.has(order.state) &&
    !CLOSED_ORDER_STATES.has(order.paymentState);
export const billetterieOrderReglementLabel = (order) => `Pass CE - commande ${order.number ?? order.id}`;
export const cseDeferredOrdersQuerySchema = z
    .object({
    startDate: z.iso.date(),
    endDate: z.iso.date(),
})
    .refine(({ startDate, endDate }) => startDate <= endDate, {
    message: 'La date de début doit précéder la date de fin',
});
export const attachBilletterieOrderSchema = z.object({
    /** As the billetterie wrote it (« 2026-10-28 10:11:12 »): the order is read back by it. */
    checkoutCompletedAt: z.string().regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/),
    cardId: z.number().int().positive(),
});
export const settleBilletterieOrderSchema = z.object({
    instrumentNumber: z.string().trim().min(1, 'Le numéro de chèque est requis'),
});
